import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import HeroSection from "../components/Home/HeroSection";
import TeamsSection from "../components/Home/TeamsSection"
import NextMatchesSection from "../components/Home/NextMatchesSection"
import FootballValuesSection from "../components/Home/FootballValuesSection";
import ResultBadge from "../components/Home/ResultBadge"
import ProjectIntroSection from "../components/Home/ProjectIntroSection"

function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <HeroSection />
      <FootballValuesSection />
      <NextMatchesSection />
      <ResultBadge />
      <ProjectIntroSection/>
      <TeamsSection />
    </>
  );
}

export default Home;